// extracted by mini-css-extract-plugin
export default {"admin_content_area":"returnPolicy_admin_content_area__f6g1g","modal_root":"returnPolicy_modal_root__4Uyaa"};